import React from "react";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import type { GatsbyImageProps } from "gatsby-plugin-image";
import type { DeepPartial } from "ts-essentials";

export interface ImageRenderProps {
  image: {
    id: number | string;
    alternativeText: string;
    localFile: DeepPartial<Queries.File>;
  };
  className?: string;
  restProps?:
    | Partial<GatsbyImageProps>
    | React.ImgHTMLAttributes<HTMLImageElement>;
}

export const ImageRender = ({
  image,
  className,
  restProps,
}: ImageRenderProps) => {
  if (
    !image?.localFile?.childImageSharp &&
    image?.localFile?.extension === "svg"
  )
    return (
      <img
        {...(restProps as React.ImgHTMLAttributes<HTMLImageElement>)}
        className={className}
        src={image.localFile.publicURL || undefined}
        alt={image.alternativeText}
        loading="lazy"
      />
    );

  if (image?.localFile?.childImageSharp?.gatsbyImageData) {
    const gatsbyImage = image.localFile.childImageSharp
      .gatsbyImageData as IGatsbyImageData;

    return (
      <GatsbyImage
        {...(restProps as GatsbyImageProps)}
        key={image.id}
        image={gatsbyImage}
        className={className}
        alt={image.alternativeText}
      />
    );
  }

  return null;
};
